import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

/**
 * Producto elegido en el selector del sidebar. Vive fuera del componente y se persiste porque la
 * elección debe sobrevivir a las vistas que no hablan de productos (p. ej. Gestión de Inventario)
 * y a la recreación del sidebar o un refresco de la página.
 */
@Injectable({
  providedIn: 'root',
})
export class ProductSelectionService {
  private readonly storageKey = 'mb-selected-product';
  private readonly selectedSubject: BehaviorSubject<string>;
  public readonly selected$;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.selectedSubject = new BehaviorSubject<string>(this.read());
    this.selected$ = this.selectedSubject.asObservable();
  }

  public get selected(): string {
    return this.selectedSubject.value;
  }

  public select(productId: string): void {
    if (!productId || productId === this.selectedSubject.value) {
      return;
    }
    this.selectedSubject.next(productId);
    this.write(productId);
  }

  private read(): string {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }
    try {
      return localStorage.getItem(this.storageKey) ?? '';
    } catch {
      return '';
    }
  }

  private write(productId: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    try {
      localStorage.setItem(this.storageKey, productId);
    } catch {
      // Sin almacenamiento (modo privado o cuota llena) la selección solo vive en memoria.
    }
  }
}
